<i18n>
zh: 
    home: 门户
    email: 邮箱
    setHome: 设为首页
ru:
    email: Электронная почта
    setHome: Установить в качестве главной страницы
</i18n>
<template>
    <div class="top">
        <div class="container">
            <router-link to="/">{{ $t('home') }}</router-link>
            <a href="https://qiye.163.com/login/?from=ym">{{ $t('email') }}</a>
            <a href="javascript:;" @click="setHome('http://www.jienengredian.com/')">{{ $t('setHome') }}</a>
            <!-- <a :href="($i18n.locale == 'zh' ? '/ru' : '') + $route.fullPath">中文 | русск</a> -->
            <a :href="($i18n.locale == 'zh' ? '/ru/#' : '/#') + $route.fullPath"><b>中文 | русск</b></a>
        </div>
    </div>
</template>

<script>
export default {
    name: "top",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        setHome( url ) {
            if(document.all){
                document.body.style.behavior='url(#default#homepage)';
                document.body.setHomePage(url);
            }else{
                alert('您的浏览器不支持自动设置页面为首页功能，请手动在浏览器里设置该页面为首页！');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.top{
    background-color: #edecec;
    border-bottom: 1px solid #c1c4c7;
    @media only screen and (max-width: 1024px) {
        display: none;
    }
    .container{
        height: 25px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    a{
        display: block;
        font-size: 14px;
        color: #15428b;
        margin-left: 35px;
    }
}
</style>